const RESET = 'reset';
const RECOVERY = 'recovery';
const AUTH = 'auth';
const BLOG_SETTINGS = 'blog-settings';
const BLOG_TEMPLATE = 'blog-template';
const BRAND_VOICE = 'brand-voice';
const LEADS = 'leads';
const HOME = 'home';
const TEAMS = 'teams';
const TEAMS_INVITE = 'teams-invite';

const DASHBOARD = 'dashboard-index';

const POSTS = {
  INDEX: 'posts-index',
  EDIT: 'posts-edit',
};

const KEYWORDS = 'keywords-index';
const NOT_FOUND = 'not-found';
const INTERNAL_SERVER_ERROR = 'internal-server-error';

const DOMAINS = {
  INDEX: 'domains-index',
  CREATE: 'domains-create',
};

const PROFILE = {
  INDEX: 'profile-index',
  SECURITY: 'profile-security',
  CONFIRM_EMAIL: 'profile-confirm-email',
  CONFIRM_DELETE_ACCOUNT: 'confirm-delete-account',
  AUTORESPONDER: 'autoresponder',
  SMTP: 'smtp',
  EMAIL_CHAINS: 'email-chains',
  DOMAINS: 'domains',
  BRAND_VOICE: 'profile-voice',
  TEAM_MEMBERS: 'team-members',
  PAYMENT_PROVIDERS: 'profile-payment-providers',
};

const RENDER = {
  BLOG: 'render-blog',
  POST: 'render-post',
  NOT_FOUND: 'render-not-found',
};

const SOCIAL = {
  INDEX: 'social-index',
  CHANNELS: 'channels',
  POST: 'social-new-post',
  CHANNELS_AUTH: 'channels-auth',
  PLANNED: 'planned',
  BRAND_VOICE: 'social-voice',
  PAYMENT_PROVIDERS: 'social-payment-providers',
};

const REPLY = {
  ADD_BRAND: 'reply-add-brand',
  MENTIONS: 'reply-mentions',
  KEYWORDS: 'reply-keywords',
  REPLIES: 'reply-replies',
  BRAND_VOICE: 'reply-voice',
  PAYMENT_PROVIDERS: 'reply-payment-providers',
};

const BOOKS = {
  INDEX: 'books-generator',
  PREVIEW: 'books-preview',
  WIZARD: 'books-wizard',
  EDITOR: 'books-editor',
  SETTINGS: 'books-settings',
  BRAND_VOICE: 'books-voice',
  DOMAINS: 'books-domains',
  EMAIL_CHAINS: 'books-email-chains',
  AUTORESPONDER: 'books-autoresponder',
  LEADS: 'books-leads',
  PAYMENT_PROVIDERS: 'books-payment-providers',
  LANDING: 'books-landing-settings',
  THANKYOU: 'books-thankyou-settings',
  PAGE_RENDER: 'books-page-render',
  NOT_FOUND: 'books-not-found',
};

const TUBE = {
  INDEX: 'tube-dashboard',
  OUTLIERS: 'tube-outliers',
  KEYWORDS: 'tube-keywords',
  MY_VIDEOS: 'tube-videos',
  MY_THUMBNAILS: 'tube-thumbnails',
  BRAND_VOICE: 'tube-voice',
};

const MY = {
  BOOK: 'my-book',
  PROFILE: 'my-profile',
  PURCHASE_HISTORY: 'my-purchase-history',
};

const WEBINARS = 'webinars';

const PAYMENT_PROVIDERS = 'payment-providers';

export default {
  RESET,
  RECOVERY,
  AUTH,
  DASHBOARD,
  POSTS,
  KEYWORDS,
  DOMAINS,
  PROFILE,
  BLOG_SETTINGS,
  BLOG_TEMPLATE,
  BRAND_VOICE,
  RENDER,
  NOT_FOUND,
  INTERNAL_SERVER_ERROR,
  WEBINARS,
  LEADS,
  HOME,
  SOCIAL,
  REPLY,
  TEAMS,
  TEAMS_INVITE,
  BOOKS,
  MY,
  PAYMENT_PROVIDERS,
  TUBE,
};
